package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SignSymptomCategory(private val literal: String) : IEnumType {
	全身症状("全身症状"),
	口腔頜面("口腔頜面"),
	头面口肩颈("头面口肩颈"),
	手足部位("手足部位"),
	腰背部位("腰背部位"),
	胸胁部位("胸胁部位"),
	胃脘及腹部("胃脘及腹部"),
	皮肤("皮肤"),
	肌肉骨骼("肌肉骨骼"),
	精神或行为("精神或行为"),
	循环系统("循环系统"),
	代谢系统("代谢系统"),
	呼吸系统("呼吸系统"),
	泌尿生殖系统("泌尿生殖系统"),
	女性生理期症状("女性生理期症状"),
	妇科疾病("妇科疾病"),
	性功能障碍("性功能障碍"),
	性病("性病"),
	损伤中毒或其他("损伤中毒或其他"),
	疾病("疾病"),
	脉象("脉象"),
	舌象("舌象"),
	发病倾向("发病倾向");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "sign_symptom_category"}
	override fun getLiteral(): String {return literal}
}
